import { SVGProps } from "react";

export default function ClockTimerIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#6B6B6B", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 5.33301V8.66634"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 1.33301H10"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33073 5.33333C2.5974 6.30667 2.16406 7.52 2.16406 8.83333C2.16406 12.0533 4.7774 14.6667 7.9974 14.6667C11.2174 14.6667 13.8307 12.0533 13.8307 8.83333C13.8307 5.61333 11.2174 3 7.9974 3C7.1574 3 6.36406 3.17333 5.64406 3.49333"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
